import { getZrmListingInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  JUMP_TO_ERROR: '9421',
} as const;

// https://dataportal.zillowgroup.net/event-registry/9421
export const JumpToErrorInteraction = ({ currentProperty }: { currentProperty: ZrmClickstreamListing }) =>
  trackEvent.listingEvent({
    envelope: {
      event_type_id: EVENT_IDS.JUMP_TO_ERROR,
      event_type_version_id: '1',
      event_template_id: '265',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'jump_to_error',
      trigger_object_nm: 'review_page_footer',
    },
    semantic: {
      semantic_event_nm: 'errors_on_review_page',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
  });

JumpToErrorInteraction.data_event_id = EVENT_IDS.JUMP_TO_ERROR;
